
import cms from '~/mixins/common/cms'
import floatingIcons from '~/mixins/common/floating-icons'
export default {
    name: 'MessageDialog',
    mixins: [cms, floatingIcons],
    data() {
        return {
            showCloseIcon: false,
            showIconTimeout: null,
            showLive: false,
        }
    },
    methods: {
        onHoverMainImg() {
            this.showCloseIcon = true
            if (this.showIconTimeout) {
                clearTimeout(this.showIconTimeout)
                this.showIconTimeout = null
            }
        },
        onHoverMainImageLeave() {
            this.showIconTimeout = setTimeout(() => {
                this.showCloseIcon = false
            }, 400)
        },
        mobileTimeout() {
            this.showCloseIcon = false
        },
        mouseLeave() {
            this.showLive = false
            this.showCloseIcon = false
        },
        onClickFab() {
            this.showLive = !this.showLive
            this.showCloseIcon = !this.showCloseIcon
            const fabOptions = document.getElementById('fab-options')
            fabOptions.setAttribute(
                'style',
                `transform: scale(${this.showLive ? '1' : '0'})`
            )
        },
        openNewWindow(link) {
            if (
                this.isMobileOnly() &&
                this.rightFloatingSupportIcon.include_sub_icon !== true
            ) {
                // This code is to making the animation for sub icons,
                // Since include_sub_icon === true, there will be no animation for the icons,
                // that's why there is one condition, rightFloatingSupportIcon.include_sub_icon must not equal to TRUE

                const fabOptions = document.getElementById('fab-options')
                fabOptions.setAttribute('style', 'transform: scale(0)')
                this.showLive = false
                this.showCloseIcon = false
            }
            window.open(
                !link.toLowerCase().startsWith('http')
                    ? 'http://' + link
                    : link,
                'Google',
                'width=550,height=600'
            )
        },
    },
}
